import { ReactNode, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { DataTable, DataTablePageParams, DataTableRowClickEventParams } from "primereact/datatable"
import { Column } from "primereact/column"
import { useUsers } from "../../../api/queries/useUsers"
import { User } from "../../../api/types/user"
import { Button } from "primereact/button"
import { createUrlParams } from "../../../api/client"
import { storage } from "../../../common/storage"

export default function UserList() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const rowClassName = (user: User) => ({
    "cursor-pointer": true,
  })

  const offsetParam: string = searchParams.get("offset") || ""
  const limitParam: string = searchParams.get("limit") || ""
  const [offset, setOffset] = useState<number>(parseInt(offsetParam) || 0)
  const [limit, setLimit] = useState<number>(parseInt(limitParam) || storage.get("limit") || 20)

  const { data: users, isLoading } = useUsers({
    limit,
    offset,
    isUserManagement: true,
  })

  useEffect(() => {
    navigate({
      search: createUrlParams({ limit, offset }),
    }, {
      replace: true,
    })
  }, [limit, offset, navigate])

  const onPage = ({ first, rows }: DataTablePageParams): void => {
    setOffset(first)
    setLimit(rows)
    storage.set("limit", rows)
  }

  const handleNewUserClick = () => navigate("/users/new")

  const handleRowClick = (row: DataTableRowClickEventParams) => {
    navigate(`/users/${row.data.uuid}`)
  }

  const tFirstName = (row: User): ReactNode => row.firstname

  const tLastName = (row: User): ReactNode => row.lastname

  const tEmail = (row: User): ReactNode => row.email

  const tIsAdmin = (row: User): ReactNode =>
    <i className={`pi pi-${row.isAdmin ? "check" : "times"}`} />

  const tCanManageUsers = (row: User): ReactNode =>
    <i className={`pi pi-${row.canManageUsers ? "check" : "times"}`} />

  return (
    <>
      <div className={"col-12"}>
        <Button label={"Nový uživatel"} icon={"pi pi-plus"} onClick={handleNewUserClick}
          className={"p-button p-button-primary p-button-sm"} />
      </div>

      <div className={"col-12"}>
        <DataTable
          emptyMessage={"Žádné záznamy"} className={"p-datatable-sm"}
          paginator={true} lazy={true} rows={limit} first={offset}
          totalRecords={users?.results.totalCount}
          loading={isLoading} onPage={onPage} value={users?.results.userList}
          onRowClick={handleRowClick} rowClassName={rowClassName} rowHover={true} stripedRows={true}
          paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"}
          rowsPerPageOptions={[20, 50, 100]}>

          <Column header={"Jméno"} body={tFirstName} />

          <Column header={"Příjmení"} body={tLastName} />

          <Column header={"E-mail"} body={tEmail} />

          <Column header={"Admin"} body={tIsAdmin} />

          <Column header={"Správce uživatelů"} body={tCanManageUsers} />
        </DataTable>
      </div>
    </>
  )
}
